import history from "../uidispatcherapi/BettyHistoryModule";

export function getShopFlavor() {
    if (typeof history.getShopFlavor === "function") {
        return history.getShopFlavor();
    }
    return null;
}
